module.exports = __webpack_public_path__ + "img/szjc14.8844286b.png";